import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { Mail, MapPin, Phone } from 'lucide-react';
import color from '../../UI/color';
import toast from 'react-hot-toast';
import vec from "../../images/image.png"
import axiosInstance from '../../services/http/interceptors/GlobalInterciptor';
const ContactUs: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<{ success: boolean; message: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post('/api/setting/contactUs', {
        email,
        message,
      });

      if (response.status === 200) {
        toast.success('Message sent successfully!' );
        setEmail('');
        setMessage('');
      }
    } catch (error: any) {
      setStatus({ success: false, message: error.response?.data?.message || 'Something went wrong!' });
    }
  };

  return (
    <>
      {/* Header Section */}
      <div style={{ backgroundColor: color.ButtonsColor }} className="text-center py-5">
        <h1 className="text-white fw-bold">Contact Us</h1>
        <p className="text-white">Home - Contact Us</p>
      </div>

      {/* Main Content Section */}
      <Container fluid className="py-md-5 p-5" style={{ backgroundColor: '#EAFBFC' }}>
        <Row className="text-center mb-4">{/* Empty row for spacing */}</Row>

        {/* Get In Touch Section */}
        <Row className="justify-content-center">
          <Col md={8} lg={6} className="text-center mb-4">
            <h3 className="fw-semibold" style={{ color: color.secondred }}>
              Get In Touch With Us
            </h3>
            <p>Leave a message and we will get back to you.</p>
          </Col>
        </Row>

        {/* Contact Form Section */}
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            {status && (
              <Alert variant={status.success ? 'success' : 'danger'}>
                {status.message}
              </Alert>
            )}
            <Form onSubmit={handleSubmit}>
              {/* Email Input */}
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Message Textarea */}
              <Form.Group className="mb-3" controlId="formMessage">
                <Form.Label>Your Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={12}
                  placeholder="Type your message here"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Submit Button */}
              <div className="text-center">
                <Button
                  variant="danger"
                  type="submit"
                  style={{ width: '100%', backgroundColor: '#d9534f' }}
                >
                  Send Message
                </Button>
                <img  className =" mt-5 w-25" src={vec} alt=""  />
              </div>
            </Form>
          </Col>
        </Row>

        {/* Other Contact Methods Section */}
        <Row className="justify-content-center mt-5 align-items-center ">
          <Col md={8} lg={6} className="text-center bg-white py-5">
            <h3 style={{ color: color.ButtonsColor }} className="fw-bold mb-4">
              Other ways to contact us
            </h3>
            <p className="d-flex justify-content-center align-items-center ">
              {/* Phone Link */}
              <a href="tel:+16472726035" className="pe-5" style={{ color: '#2F5466' }}>
                <Phone className="me-1" size={20} />
                +1(289) 919-3371
              </a>

              {/* Email Link */}
              <a href="mailto:Sales@champstravel.ca" className="text-center pt-3 pt-md-0" style={{ color: '#2F5466' }}>
                <Mail className="me-2" size={20} />
                Sales@champstravel.ca
              </a>
            </p>

            {/* Address Section */}
            <div className='pt-1'>
              <MapPin size={20} className="me-1" style={{ color: '#2F5466' }} />
              4145 N Service Rd, Burlington, ON, Canada L7L, 6A3
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ContactUs;
